import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import ShortlistlyLanding from "./components/ShortlistlyLanding";
import CareerHub from "./components/CareerHub";
import UserDashboard from "./components/UserDashboard";
import FreemiumResumeApp from "./components/FreemiumResumeApp";
import PricingPage from "./components/PricingPage";
import AuthCallback from "./components/AuthCallback";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsConditions from "./components/pages/TermsConditions";
import RefundPolicy from "./components/pages/RefundPolicy";
import ShippingPolicy from "./components/pages/ShippingPolicy";
import ContactUs from "./components/pages/ContactUs";

// Protected Route Component
const ProtectedRoute = ({ children, requiredAuth = true }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (requiredAuth && !user) {
    return <Navigate to="/" replace />;
  }

  if (!requiredAuth && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Main App Router Component
const AppRouter = () => {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <ProtectedRoute requiredAuth={false}>
            <ShortlistlyLanding />
          </ProtectedRoute>
        } />
        
        {/* Authentication Callback Route */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Public Pricing Page */}
        <Route path="/pricing" element={<PricingPage />} />
        
        {/* Resume Optimizer for non-authenticated users */}
        <Route path="/resume-optimizer" element={
          user ? <Navigate to="/dashboard" replace /> : <FreemiumResumeApp />
        } />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/career-hub" element={
          <ProtectedRoute>
            <CareerHub />
          </ProtectedRoute>
        } />

        {/* Static Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy onBack={() => window.history.back()} />} />
        <Route path="/terms-conditions" element={<TermsConditions onBack={() => window.history.back()} />} />
        <Route path="/refund-policy" element={<RefundPolicy onBack={() => window.history.back()} />} />
        <Route path="/shipping-delivery" element={<ShippingPolicy onBack={() => window.history.back()} />} />
        <Route path="/contact-us" element={<ContactUs onBack={() => window.history.back()} />} />

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRouter />
      </div>
    </AuthProvider>
  );
}

export default App;